import { ComboBox } from "@/components/ui/combobox"
import { Input } from "@/components/ui/input"
import { SelectorTypeProps, SelectorInputTypeProps } from "../Interface"

export function TypeComponent({type, value, setValue}: {type: SelectorTypeProps, value: string, setValue: (value: SelectorInputTypeProps) => void}) {
    switch (type) {
        case "date":
            return <DateField defaultValue={value} setValue={setValue} />
        case "string":
            return <StringField defaultValue={value} setValue={setValue} />
        case "number":
            return <NumberField defaultValue={value} setValue={setValue} />
        case "boolean":
            return <BooleanField defaultValue={value} setValue={setValue} />
        default:
            console.error("Invalid type", type)
            return <div>Invalid type</div>
    }
}

export function DateField({defaultValue, setValue}: {defaultValue: string, setValue: (value: SelectorInputTypeProps) => void}) {
    return (
        <Input 
            type="date" 
            defaultValue={defaultValue} 
            onChange={(e) => setValue(e.target.value)} 
        />
    )
}

export function StringField({defaultValue, setValue}: {defaultValue: string, setValue: (value: SelectorInputTypeProps) => void}) {
    return (
        <Input 
            type="text" 
            defaultValue={defaultValue} 
            onChange={(e) => setValue(e.target.value)} 
        />
    )
}

export function NumberField({defaultValue, setValue}: {defaultValue: string, setValue: (value: SelectorInputTypeProps) => void}) {
    return (
        <Input 
            type="number" 
            defaultValue={defaultValue} 
            onChange={(e) => setValue(Number(e.target.value))} 
        />
    )
}

export function BooleanField({defaultValue, setValue}: {defaultValue: string, setValue: (value: SelectorInputTypeProps) => void}) {
    const isChecked = defaultValue === "true" || (typeof defaultValue === "boolean" && defaultValue)
    
    return (
        <Input 
            type="checkbox" 
            defaultChecked={isChecked} 
            onChange={(e) => setValue(e.target.checked)} 
        />
    )
}

export function OptionsField({defaultValue, setValue, options}: {defaultValue: string, setValue: (value: SelectorInputTypeProps) => void, options: { value: string, label: string }[]}) {
    return (
        <ComboBox 
            label="Please select an option" 
            placeholder="Select an option" 
            options={options} 
            value={defaultValue}
            onChange={setValue} 
        />
    )
}